<p-floatlabel class="w-full" variant="on">
  <p-multiselect [autofocusFilter]="true"
                 [formControl]="this.control()"
                 [maxSelectedLabels]="3"
                 [options]="this.items()"
                 [selectedItemsLabel]="'app.items-selected' | translate"
                 appendTo="body"
                 display="chip"
                 fluid
                 optionLabel="{{this.textField()}}"
                 optionValue="{{this.valueField()}}"
  >

  </p-multiselect>
  <label>
    {{ this.label() | translate }}
    @if (isRequired()) {
      <span class="text-red-500">*</span>
    }
  </label>
</p-floatlabel>
